import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function PortfolioDetail() {
  const { id } = useParams();
  const { i18n, t } = useTranslation();
  const [p, setP] = useState(null);
  const isIT = i18n.language.startsWith("it");

  useEffect(() => {
    api.get(`/portfolio/${id}`).then((r) => setP(r.data)).catch(() => {});
  }, [id]);

  if (!p) return <div className="max-w-7xl mx-auto px-6 py-20 text-stone-600">Loading…</div>;

  const gallery = [p.cover_url, ...(p.image_urls || [])].filter(Boolean);

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
      <Link to="/portfolio" data-testid="portfolio-back" className="inline-flex items-center gap-2 text-sm text-stone-700 hover:text-[#D06D4D]">
        <ArrowLeft size={16} /> {t("portfolio.title")}
      </Link>
      <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2">
          <div className="eyebrow">{p.category} · {p.year}</div>
          <h1 className="font-serif text-4xl lg:text-5xl mt-4 text-stone-900" data-testid="portfolio-detail-title">
            {isIT ? p.title_it : p.title_en}
          </h1>
        </div>
        <p className="text-stone-700 leading-relaxed">{isIT ? p.description_it : p.description_en}</p>
      </div>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
        {gallery.map((src, i) => (
          <img key={src} src={src} alt="" loading={i === 0 ? "eager" : "lazy"} decoding="async" className={`w-full object-cover ${i === 0 ? "md:col-span-2 h-[520px]" : "h-[380px]"}`} />
        ))}
      </div>
    </div>
  );
}
